import { useNuxtApp } from "#app";
import type { Mixpanel } from "mixpanel-browser";

export function useMixpanel() {
   // Get the Mixpanel instance provided by the plugin
   const $mixpanel = useNuxtApp().$mixpanel as Mixpanel;

   /**
    * Track an event with optional properties.
    * @param event - The event name.
    * @param properties - Additional event properties.
    */
   function track(event: string, properties?: Record<string, any>) {
      $mixpanel.track(event, properties || {});
      
   }

   /**
    * Identify a user by their unique id.
    * @param userId - The unique identifier of the user.
    */
   function identify(userId: string) {
      $mixpanel.identify(userId);
   }

   /**
    * Create an alias for the user.
    * @param userId - The unique identifier to alias.
    */
   function alias(userId: string) {
      $mixpanel.alias(userId);
   }

   /**
    * Set people properties.
    * @param properties - The object of properties to set.
    */
   function peopleSet(properties: Record<string, any>, once: boolean = false) {
      if (once) {
         $mixpanel.people.set_once(properties);
      } else {
         $mixpanel.people.set(properties);
      }
   }
   /**
    * Clear Mixpanel.
    */
   function resetUser() {
      $mixpanel?.reset();
   }

   return {
      track,
      identify,
      alias,
      peopleSet,
      resetUser,
   };
}
